// extracted by mini-css-extract-plugin
export var layoutContainer = "_5v-0";
export var layoutContainerNoRounding = "_5v-6";
export var layoutContainerOpen = "_5v-5";
export var layoutContainerResizing = "_5v-1";
export var mainContent = "_5v-2";
export var resizeDivider = "_5v-3";
export var slidePanel = "_5v-4";